import { Component, OnInit, QueryList, ViewChild, ViewChildren, OnDestroy, Inject, PLATFORM_ID, NgZone, ElementRef, AfterViewInit } from '@angular/core';
import { BehaviorSubject, combineLatest, ReplaySubject, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { EditableContentPlaceholderDirective } from 'src/app/share/directive/editable-content-placeholder.directive';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { SwiperDirective } from 'src/app/swiper/swiper.directive';
import { isSupportObjectFit } from 'src/app/util';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { SECTION_DATA } from 'src/app/web-generator/index-section-generator/service/section-data';
import { SubjectTemplate } from 'src/app/web-generator/subject-generator/entity/subject-template';
import { SubjectTemplateService } from 'src/app/web-generator/subject-generator/service/subject-template.service';
import { Section } from 'src/app/web-generator/template-generator/entity/section';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { SwiperOptions } from 'swiper';
import { AbstractIndexSubject } from '../../abstract-index-subject';
import { IndexSubjectCollection } from '../../index-subject-collection';

@Component({
  selector: 'app-index-subject-01',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent extends AbstractIndexSubject implements OnInit, AfterViewInit, OnDestroy {
  readonly isSupportObjectFit = isSupportObjectFit;
  readonly remoteDefaultData: IndexSubjectCollection[] = [
    {
      id: 0,
      title: '口罩是最好的防疫武器',
      description: '',
      image: '/assets/images/v040/img-400-01.webp',
      isSubject: true,
    },
    {
      id: 0,
      title: '國境大門防疫第一線',
      description: '',
      image: '/assets/images/v040/img-400-02.webp',
      isSubject: true,
    },
    {
      id: 0,
      title: '人權勝利！',
      description: '',
      image: '/assets/images/v040/img-400-03.webp',
      fetchIndex: 'Culture_Object',
      isSubject: false,
    },
    {
      id: 0,
      title: '懸日下的疫情',
      description: '',
      image: '/assets/images/v040/img-400-04.webp',
      fetchIndex: 'Culture_Object',
      isSubject: false,
    },
    {
      id: 0,
      title: '懸日下的疫情',
      description: '',
      image: '/assets/images/v040/img-400-04.webp',
      fetchIndex: 'Culture_Object',
      isSubject: false,
    },
  ];
  defaultData: any = {
    title: '',
    subTitle: '',
    pickedSubjects: [],
    pickedCollections: [],
  };
  swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    // loop: true,
    lazy: true,
    // navigation: {
    //   nextEl: `#sec-${this.data.uuid} .swiper-button-next`,
    //   prevEl: `#sec-${this.data.uuid} .swiper-button-prev`,
    // },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
      },
    }
  };
  @ViewChildren('slideRef') slideRefs: QueryList<HTMLElement>;
  protected dataSwiper$ = new BehaviorSubject<SwiperDirective>(undefined);
  @ViewChild('dataSwiper', {static: false}) set dataSwiper(swiperDir: SwiperDirective) {
    this.dataSwiper$.next(swiperDir);
  }
  get dataSwiper() {
    return this.dataSwiper$.value;
  }
  private _slideChangeSubc: Subscription;
  private swiperSlideContainer$ = new BehaviorSubject<ElementRef>(undefined);
  @ViewChild('swiperSlideContainer', {static: false}) set swiperSlideContainer(ref: ElementRef) {
    if (ref) {
      this.swiperSlideContainer$.next(ref);
    } else if (!this.swiperSlideContainer) {
      this.swiperSlideContainer$.next(null);
    }
  }
  get swiperSlideContainer() {
    return this.swiperSlideContainer$.value;
  }
  private changes: MutationObserver;
  protected slideCountChange$ = new ReplaySubject<number>();
  protected swiperPluginSubc: Subscription;
  protected _checkWeatherDoReInitSwiper: Subscription;
  @ViewChild('titlePlaceholder', {static: false}) titlePlaceholder: EditableContentPlaceholderDirective;
  
  /** 是否可以設定要不要顯示"顯示更多"按鈕 */
  canSetShowMoreBtn = true;

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected subjectTemplateService: SubjectTemplateService,
    protected templateService: TemplateService,
    protected zone: NgZone,
    protected http: CommonHttpClientService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, subjectTemplateService, templateService, zone);
  }

  ngAfterViewInit(): void {
    if (this.isBrowser && typeof MutationObserver !== 'undefined') {
      this.changes = new MutationObserver((mutations: MutationRecord[]) => {
        this.slideCountChange$.next((this.swiperSlideContainer.nativeElement as HTMLElement).childElementCount);
      });
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();

    this.stopWatchSlideChange();
    this.cancelObserveDomChange();
    if (this.slideCountChange$) {
      this.slideCountChange$.complete();
      delete this.slideCountChange$;
    }
    if (this.swiperPluginSubc) {
      this.swiperPluginSubc.unsubscribe();
      delete this.swiperPluginSubc;
    }
    if (this._checkWeatherDoReInitSwiper) {
      this._checkWeatherDoReInitSwiper.unsubscribe();
    }
  }

  protected onRmtDataSetted() {
    if (this.data.pickedCollections.length || this.data.pickedSubjects.length > 1) {
      this.canSetShowMoreBtn = false;
      this.data['showMoreButton'] = false;
    } else {
      this.canSetShowMoreBtn = true;
      this.data['showMoreButton'] = undefined;
    }

    if (this._checkWeatherDoReInitSwiper) {
      this._checkWeatherDoReInitSwiper.unsubscribe();
      delete this._checkWeatherDoReInitSwiper;
    }

    this._checkWeatherDoReInitSwiper = combineLatest(
      this.swiperSlideContainer$.pipe(filter(swiperSlideContainer => !!swiperSlideContainer), take(1)),
      this.dataSwiper$.pipe(filter(dataSwiper => !!dataSwiper), take(1)),
    ).pipe(
      take(1)
    ).subscribe(([swiperSlideContainer, dataSwiper]) => {
      if (dataSwiper.canInit) {
        if (dataSwiper.hasInited) {
          dataSwiper.destroy();
        } else {
          dataSwiper.noInit = true;
        }
        this.startWatchSlideChange();
      } else {
        dataSwiper.noInit = true;
        this.swiperPluginSubc = SwiperDirective.pulginInit.subscribe(() => {
          this.startWatchSlideChange();
        });
      }
    });
  }

  setSubjectToData(subject: SubjectTemplate) {
    super.setSubjectToData(subject);
    this.titlePlaceholder.isTextExisting = true;
    this.titlePlaceholder.setPlaceholder('請輸入標題');
  }

  startWatchSlideChange() {
    if ((this.swiperSlideContainer.nativeElement as HTMLElement).childElementCount === this.remoteData.length
    && this.slideRefs.length === this.remoteData.length) {
      this.dataSwiper.init();
    } else {
      this.startObserveDomChange();

      this._slideChangeSubc = combineLatest(
        this.slideCountChange$,
        this.slideRefs.changes,
      ).pipe(
        filter(([slideCount, changes]) => changes.length === this.remoteData.length && slideCount === this.remoteData.length),
      ).subscribe(([slideCount, changes]) => {
        this.stopWatchSlideChange();
        this.cancelObserveDomChange();
        this.dataSwiper.init();
      });
    }
  }

  stopWatchSlideChange() {
    if (this._slideChangeSubc) {
      this._slideChangeSubc.unsubscribe();
      delete this._slideChangeSubc;
    }
  }

  startObserveDomChange() {
    if (this.changes) {
      this.changes.observe(this.swiperSlideContainer.nativeElement, {
        attributes: false,
        childList: true,
        characterData: false
      });
    }
  }

  cancelObserveDomChange() {
    if (this.changes) {
      this.changes.disconnect();
    }
  }
}
